import { Typography } from "@acin.reactjs/acin-ui/theme";

export const fontFamilyRubik = "'Rubik', Arial";

const TypographyTheme: Partial<Typography> = {
  default: {
    fontFamily: "'Source Sans 3', Arial",
    lineHeight: "18px",
    fontSize: "14px",
    fontWeight: 400,
  },
  headings: {
    h1: {
      lg: {
        fontFamily: fontFamilyRubik,
      },
    },
    h2: {
      lg: {
        fontFamily: fontFamilyRubik,
        fontSize: "42px",
        fontWeight: 400,
        lineHeight: "46px",
      },
      md: {
        fontSize: "26px",
        lineHeight: "32px",
      },
    },
    h3: {
      lg: {
        fontFamily: fontFamilyRubik,
        fontSize: "20px",
        fontWeight: 400,
        lineHeight: "24px",
      },
      md: {
        fontSize: "16px",
        lineHeight: "20px",
      },
      sm: {
        fontSize: "16px",
        lineHeight: "20px",
      },
    },
    h4: {
      lg: {
        fontFamily: fontFamilyRubik,
      },
    },
    h5: {
      lg: {
        fontFamily: fontFamilyRubik,
      },
    },
    h6: {
      lg: {
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 400,
      },
    },
  },
};

export default TypographyTheme;
